import { APPROVALS_REMOVE_APPROVER_EXPERIENCE } from '@confluence/experience-tracker/entry-points/ExperienceName.ts';

import {
	type ApprovalsWriteExperience,
	useApprovalsWriteExperience,
} from './useApprovalsWriteExperience.ts';

/**
 * Tracks `approvals/remove-approver` — an approver was removed from an active review.
 */
export const useRemoveApproverExperience = (): ApprovalsWriteExperience =>
	useApprovalsWriteExperience(APPROVALS_REMOVE_APPROVER_EXPERIENCE);
